import bitgetWalletIcon from '@ui/assets/bitget-wallet.svg';
import { injected } from 'wagmi/connectors';

export const bitgetConnector = () => {
    const c = injected({
        target: {
            id: 'com.bitget.web3',
            name: 'Bitget Wallet Injected',

            // @ts-ignore
            provider: () => window?.bitkeep?.ethereum,
        },
        // @ts-ignore
        shimDisconnect: true,
    });

    return (ctx: any) => {
        const connector = c(ctx);
        
return {
            ...connector,
            getProvider: () => connector.getProvider(),
            id: 'com.bitget.web3',
            name: 'Bitget Wallet',
            icon: bitgetWalletIcon.src,
            getWalletConnectDeeplink: null,
            // @ts-ignore
            isAuthorized: async () => {
                if (typeof window !== 'undefined' && !(window as any).bitkeep) {
                    return false;
                }
                
return connector.isAuthorized();
            },
            get suggested() {
                return true;
            },
            get display() {
                return false;
            },
            // Manually specify installed status to force ConnectKit to check immediately
            // This relies on ConnectKit checking this property (some versions do)
            // or the ready state from the connector instance
            get installed() {
                return typeof window !== 'undefined' && !!(window as any).bitkeep;
            },
            extension: {
                instructions: {
                    learnMoreUrl: 'https://web3.bitget.com/en/wallet-download?type=1',
                    steps: [],
                },
            },
            downloadUrls: {
                get download() {
                    if (typeof window === 'undefined')
                        return 'https://web3.bitget.com/en/wallet-download?type=1';
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(
                        window.navigator.userAgent,
                    );
                    if (isMobile) {
                        return `https://bkcode.vip?action=dapp&_nobar&_needChain=monad&url=${encodeURIComponent(
                            window.location.href,
                        )}`;
                    }
                    
return 'https://web3.bitget.com/en/wallet-download?type=1';
                },
            },
        };
    };
};
